import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { ArrowLeft, Mail } from 'lucide-react';
import api from '../../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md">
        <h1 className="text-2xl font-bold text-emerald-700 mb-8" style={{ fontFamily: 'Outfit' }}>Jjuma Pay</h1>

        {sent ? (
          <div className="text-center" data-testid="forgot-success">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-emerald-100 flex items-center justify-center">
              <Mail size={28} className="text-emerald-600" />
            </div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>Check your email</h2>
            <p className="text-slate-500 text-sm mb-6">If this email exists, a password reset link has been sent. Check your inbox and spam folder.</p>
            <Link to="/login" className="text-emerald-700 font-medium text-sm hover:underline">Back to login</Link>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-semibold text-slate-900 mb-1" style={{ fontFamily: 'Outfit' }}>Forgot password?</h2>
            <p className="text-slate-500 text-sm mb-6">Enter your email and we'll send you a reset link</p>

            {error && <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm" data-testid="forgot-error">{error}</div>}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-slate-700">Email address</Label>
                <Input id="email" type="email" data-testid="forgot-email-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" className="mt-1.5" required />
              </div>
              <Button type="submit" data-testid="forgot-submit-btn" disabled={loading} className="w-full bg-emerald-700 hover:bg-emerald-800 text-white">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>

            <p className="mt-6 text-center">
              <Link to="/login" className="text-sm text-slate-500 hover:text-slate-700 inline-flex items-center gap-1" data-testid="back-to-login">
                <ArrowLeft size={14} /> Back to login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
